/** Custo sobre o qual o markup forma o preço de venda. Espelha o TipoBasePrecoVendaEnum do back-end. */
export enum TipoBasePrecoVendaEnum {
  PrecoCustoCompra = 1,
  CustoMedio = 2,
}
